import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Directive({
  selector: '[imgLoader-dir]',
  exportAs: 'imgLoader',
  standalone: false,
})
export class ImageLoaderDirective {
  readonly imageBrokenSrc = 'assets/img/umpire/icon-32-image-broken.svg';

  private readonly showLoaderSubject$ = new BehaviorSubject<boolean>(true);

  readonly showLoader$: Observable<boolean> = this.showLoaderSubject$.asObservable();

  _imgSrc = '';

  @Input() set imageSrc(val: string) {
    if (val !== this._imgSrc) {
      this._imgSrc = val;
      this.renderer.setAttribute(this.elementRef.nativeElement, 'src', '');
      this.showLoaderSubject$.next(true);
      this._cdr.detectChanges();
    }
  }

  get imageSrc() {
    return this._imgSrc;
  }

  @Output() imageBroken = new EventEmitter<boolean>();

  constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2,
    private readonly _cdr: ChangeDetectorRef,
  ) {
    this.renderer.listen(this.elementRef.nativeElement, 'error', () =>
      this.onImageError(),
    );

    this.renderer.listen(this.elementRef.nativeElement, 'load', () => this.onImageLoad());
  }

  onImageLoad(): void {
    this.showLoaderSubject$.next(false);
    this.imageBroken.emit(
      this.elementRef.nativeElement.src.includes(this.imageBrokenSrc),
    );
  }

  onImageError(): void {
    if (this.imageBrokenSrc) {
      this.renderer.setAttribute(
        this.elementRef.nativeElement,
        'src',
        this.imageBrokenSrc,
      );
    }
    this.showLoaderSubject$.next(false);
  }
}
